export const urlParamsFromStoreType = (store, info) => {
  let urlParams = "";
  if (store.type === "lodge") {
    urlParams += "?adults=" + info.lodge.adults;
    urlParams += "&children=" + info.lodge.children;
    urlParams +=
      "&check-in=" + info.lodge.checkIn?.toISOString(true).split("T")[0];
    urlParams +=
      "&check-out=" + info.lodge.checkOut?.toISOString(true).split("T")[0];
  }
  if (store.type === "restaurant") {
    urlParams += "?people=" + info.restaurant.people;
    urlParams +=
      "&date=" + info.restaurant.date?.toISOString(true).split("T")[0];
    urlParams += "&service=" + info.restaurant.service;
    urlParams += "&time=" + info.restaurant.time;
  }
  if (store.type === "experience") {
    urlParams += "?people=" + info.experience.people;
    urlParams +=
      "&date=" + info.experience.date?.toISOString(true).split("T")[0];
    urlParams += "&category=" + info.experience.category;
    urlParams += "&duration=" + info.experience.duration;
  }
  return urlParams;
};
